import React, { useState, useEffect, useCallback } from 'react';
import {
  Container, Card, Row, Col, Table, Button, Form, Badge, Spinner, InputGroup,
} from 'react-bootstrap';
import Select from 'react-select';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FaChevronRight, FaSort, FaSortUp, FaSortDown, FaPlus, FaSearch, FaChevronLeft } from 'react-icons/fa';
import Header from '~/Components/Header/Header';
import { listarContas, listarTodosGruposEmpresa } from '~/Services/Service';

var TAMANHO_PAGINA = 25;

var TIPOS_CONTA = [
  { value: 1, label: '1 - Cliente Factoring' },
  { value: 2, label: '2 - Cliente Comércio' },
  { value: 3, label: '3 - Despesa' },
  { value: 4, label: '4 - Fornecedor' },
  { value: 5, label: '5 - Banco' },
  { value: 6, label: '6 - Interna' },
  { value: 7, label: '7 - Receita' },
  { value: 8, label: '8 - Funcionário/Prest.Serviço' },
];

var STATUS_CONTA = [
  { value: 0, label: 'Ativo' },
  { value: 1, label: 'Inativo' },
  { value: 2, label: 'Negativado' },
];

var getStatusBadge = function (status) {
  if (status === 0 || status === '0') return <Badge variant="success">Ativo</Badge>;
  if (status === 1 || status === '1') return <Badge variant="danger">Inativo</Badge>;
  if (status === 2 || status === '2') return <Badge variant="warning">Negativado</Badge>;
  return <Badge variant="secondary">{status}</Badge>;
};

var thSortStyle = { cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' };

var ContaListagem = function () {
  var history = useHistory();

  var [contas, setContas] = useState([]);
  var [loading, setLoading] = useState(true);
  var [opcoesGe, setOpcoesGe] = useState([]);

  // Filtros
  var [filtroGe, setFiltroGe] = useState(null);
  var [filtroTipo, setFiltroTipo] = useState(null);
  var [filtroStatus, setFiltroStatus] = useState(null);
  var [busca, setBusca] = useState('');
  var [buscaTemp, setBuscaTemp] = useState('');

  // Paginação
  var [pagina, setPagina] = useState(1);
  var [total, setTotal] = useState(0);

  // Ordenação
  var [ordenacao, setOrdenacao] = useState({ campo: 'codigo_conta', direcao: 'asc' });

  // Carrega GEs para o filtro
  useEffect(function () {
    listarTodosGruposEmpresa()
      .then(function (res) {
        var lista = Array.isArray(res) ? res : [];
        setOpcoesGe(lista.map(function (ge) {
          return { value: ge.codigo, label: ge.codigo + ' - ' + ge.apelido };
        }));
      })
      .catch(function () {});
  }, []);

  var carregarContas = useCallback(async function () {
    setLoading(true);
    try {
      var params = { pagina: pagina, tamanhoPagina: TAMANHO_PAGINA };
      if (filtroGe) params.ge = filtroGe.value;
      if (filtroTipo) params.tipo = filtroTipo.value;
      if (filtroStatus !== null && filtroStatus !== undefined) params.status = filtroStatus.value;
      if (busca) params.busca = busca;

      var resp = await listarContas(params);
      var itens = Array.isArray(resp) ? resp : (resp.itens ? resp.itens : []);
      setContas(itens);
      setTotal(resp.total ? resp.total : itens.length);
    } catch (e) {
      toast.error('Erro ao carregar contas');
    } finally {
      setLoading(false);
    }
  }, [filtroGe, filtroTipo, filtroStatus, busca, pagina]);

  useEffect(function () {
    carregarContas();
  }, [carregarContas]);

  var handleBuscar = function () {
    setBusca(buscaTemp);
    setPagina(1);
  };

  var handleKeyDown = function (e) {
    if (e.key === 'Enter') handleBuscar();
  };

  var handleOrdenacao = function (campo) {
    setOrdenacao(function (prev) {
      return {
        campo: campo,
        direcao: prev.campo === campo && prev.direcao === 'asc' ? 'desc' : 'asc',
      };
    });
  };

  var iconeOrdenacao = function (campo) {
    if (ordenacao.campo !== campo) return <FaSort style={{ opacity: 0.3, marginLeft: 4 }} />;
    return ordenacao.direcao === 'asc'
      ? <FaSortUp style={{ marginLeft: 4 }} />
      : <FaSortDown style={{ marginLeft: 4 }} />;
  };

  var contasOrdenadas = contas.slice().sort(function (a, b) {
    var va = a[ordenacao.campo];
    var vb = b[ordenacao.campo];
    if (va === null || va === undefined) return 1;
    if (vb === null || vb === undefined) return -1;
    if (typeof va === 'number') return ordenacao.direcao === 'asc' ? va - vb : vb - va;
    var sa = String(va).toLowerCase();
    var sb = String(vb).toLowerCase();
    if (sa < sb) return ordenacao.direcao === 'asc' ? -1 : 1;
    if (sa > sb) return ordenacao.direcao === 'asc' ? 1 : -1;
    return 0;
  });

  var totalPaginas = Math.ceil(total / TAMANHO_PAGINA);

  return (
    <Container fluid className="px-0 contas-listagem">

      <Header title="Manutenção de Contas">
        <Button
          variant="success"
          size="sm"
          onClick={function () { history.push('/contas/novo'); }}
        >
          <FaPlus className="mr-1" /> Nova Conta
        </Button>
      </Header>

      <div className="px-3 py-3">
        {/* Filtros */}
        <Card className="shadow-sm mb-3">
          <Card.Body className="py-2">
            <Row className="align-items-end">
              <Col md={3} className="mb-2">
                <Form.Label className="small mb-1">Grupo de Empresa</Form.Label>
                <Select
                  placeholder="Todos os GEs"
                  isClearable
                  value={filtroGe}
                  options={opcoesGe}
                  onChange={function (v) { setFiltroGe(v); setPagina(1); }}
                  noOptionsMessage={function () { return 'Nenhum GE encontrado'; }}
                />
              </Col>
              <Col md={2} className="mb-2">
                <Form.Label className="small mb-1">Tipo</Form.Label>
                <Select
                  placeholder="Todos"
                  isClearable
                  value={filtroTipo}
                  options={TIPOS_CONTA}
                  onChange={function (v) { setFiltroTipo(v); setPagina(1); }}
                />
              </Col>
              <Col md={2} className="mb-2">
                <Form.Label className="small mb-1">Status</Form.Label>
                <Select
                  placeholder="Todos"
                  isClearable
                  value={filtroStatus}
                  options={STATUS_CONTA}
                  onChange={function (v) { setFiltroStatus(v); setPagina(1); }}
                />
              </Col>
              <Col md={3} className="mb-2">
                <Form.Label className="small mb-1">Buscar por código ou apelido</Form.Label>
                <InputGroup size="sm">
                  <Form.Control
                    placeholder="Código ou apelido..."
                    value={buscaTemp}
                    onChange={function (e) { setBuscaTemp(e.target.value); }}
                    onKeyDown={handleKeyDown}
                  />
                  <InputGroup.Append>
                    <Button variant="primary" onClick={handleBuscar}>
                      <FaSearch />
                    </Button>
                  </InputGroup.Append>
                </InputGroup>
              </Col>
              <Col md={2} className="mb-2 text-right d-flex align-items-end">
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={function () {
                    setFiltroGe(null);
                    setFiltroTipo(null);
                    setFiltroStatus(null);
                    setBusca('');
                    setBuscaTemp('');
                    setPagina(1);
                  }}
                >
                  Limpar filtros
                </Button>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {/* Grid */}
        <Card className="shadow-sm">
          <Card.Header
            className="d-flex justify-content-between align-items-center py-2"
            style={{ backgroundColor: '#0747a6', color: '#fff' }}
          >
            <strong>
              Contas
              <span className="ml-2" style={{ fontSize: '0.85rem', opacity: 0.8 }}>
                {loading ? '(carregando...)' : '(' + total.toLocaleString('pt-BR') + ' registros)'}
              </span>
            </strong>
            {totalPaginas > 1 && (
              <div className="d-flex align-items-center" style={{ gap: 8 }}>
                <Button
                  size="sm"
                  variant="outline-light"
                  disabled={pagina <= 1 || loading}
                  onClick={function () { setPagina(function (p) { return p - 1; }); }}
                >
                  <FaChevronLeft />
                </Button>
                <span style={{ fontSize: '0.85rem' }}>
                  Pág. {pagina} / {totalPaginas}
                </span>
                <Button
                  size="sm"
                  variant="outline-light"
                  disabled={pagina >= totalPaginas || loading}
                  onClick={function () { setPagina(function (p) { return p + 1; }); }}
                >
                  <FaChevronRight />
                </Button>
              </div>
            )}
          </Card.Header>
          <Card.Body className="p-0">
            {loading ? (
              <div className="text-center py-5">
                <Spinner animation="border" variant="primary" />
                <p className="text-muted mt-2 mb-0">Carregando contas...</p>
              </div>
            ) : (
              <>
                {/* Desktop */}
                <div className="contas-desktop">
                  <Table striped bordered hover size="sm" className="mb-0">
                    <thead>
                      <tr>
                        <th style={Object.assign({ width: 80 }, thSortStyle)} onClick={function () { handleOrdenacao('codigo_conta'); }}>
                          Código{iconeOrdenacao('codigo_conta')}
                        </th>
                        <th style={thSortStyle} onClick={function () { handleOrdenacao('apelido_conta'); }}>
                          Apelido{iconeOrdenacao('apelido_conta')}
                        </th>
                        <th style={thSortStyle} onClick={function () { handleOrdenacao('tipo_descricao'); }}>
                          Tipo{iconeOrdenacao('tipo_descricao')}
                        </th>
                        <th style={thSortStyle} onClick={function () { handleOrdenacao('grupo_descricao'); }}>
                          Categoria{iconeOrdenacao('grupo_descricao')}
                        </th>
                        <th style={{ width: 100 }}>Status</th>
                        <th style={Object.assign({ width: 60 }, thSortStyle)} onClick={function () { handleOrdenacao('codigo_grupo_empresa'); }}>
                          GE{iconeOrdenacao('codigo_grupo_empresa')}
                        </th>
                        <th style={{ width: 36 }}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {contasOrdenadas.length === 0 ? (
                        <tr>
                          <td colSpan={7} className="text-center py-4 text-muted">
                            Nenhuma conta encontrada. Use os filtros acima para buscar.
                          </td>
                        </tr>
                      ) : (
                        contasOrdenadas.map(function (c) {
                          return (
                            <tr
                              key={c.codigo_grupo_empresa + '-' + c.codigo_conta}
                              style={{ cursor: 'pointer' }}
                              onClick={function () {
                                history.push('/contas/' + c.codigo_grupo_empresa + '/' + c.codigo_conta);
                              }}
                            >
                              <td><strong>{c.codigo_conta}</strong></td>
                              <td>{c.apelido_conta}</td>
                              <td><small>{c.tipo_descricao ? c.tipo_descricao : '-'}</small></td>
                              <td><small>{c.grupo_descricao ? c.grupo_descricao : '-'}</small></td>
                              <td>{getStatusBadge(c.status)}</td>
                              <td className="text-center">
                                <Badge variant="secondary">{c.codigo_grupo_empresa}</Badge>
                              </td>
                              <td className="text-center">
                                <FaChevronRight size={11} className="text-muted" />
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </Table>
                </div>

                {/* Mobile */}
                <div className="contas-mobile p-2">
                  {contasOrdenadas.length === 0 ? (
                    <p className="text-center text-muted py-3">
                      Nenhuma conta encontrada. Use os filtros acima para buscar.
                    </p>
                  ) : (
                    contasOrdenadas.map(function (c) {
                      return (
                        <Card
                          key={c.codigo_grupo_empresa + '-' + c.codigo_conta}
                          className="mb-2 shadow-sm"
                          style={{ cursor: 'pointer' }}
                          onClick={function () {
                            history.push('/contas/' + c.codigo_grupo_empresa + '/' + c.codigo_conta);
                          }}
                        >
                          <Card.Body className="py-2 px-3">
                            <div className="d-flex justify-content-between align-items-start">
                              <div>
                                <strong>{c.codigo_conta}</strong> — {c.apelido_conta}
                                <br />
                                <small className="text-muted">
                                  {c.tipo_descricao ? c.tipo_descricao : '-'} | GE {c.codigo_grupo_empresa}
                                </small>
                              </div>
                              <div className="d-flex align-items-center">
                                {getStatusBadge(c.status)}
                                <FaChevronRight size={11} className="text-muted ml-2" />
                              </div>
                            </div>
                          </Card.Body>
                        </Card>
                      );
                    })
                  )}
                </div>

                {/* Paginação rodapé */}
                {totalPaginas > 1 && (
                  <div className="d-flex justify-content-between align-items-center px-3 py-2 border-top">
                    <small className="text-muted">
                      Exibindo {(pagina - 1) * TAMANHO_PAGINA + 1}–{Math.min(pagina * TAMANHO_PAGINA, total)} de {total.toLocaleString('pt-BR')} registros
                    </small>
                    <div className="d-flex align-items-center" style={{ gap: 4 }}>
                      <Button
                        size="sm"
                        variant="outline-secondary"
                        disabled={pagina <= 1}
                        onClick={function () { setPagina(1); }}
                      >
                        «
                      </Button>
                      <Button
                        size="sm"
                        variant="outline-secondary"
                        disabled={pagina <= 1}
                        onClick={function () { setPagina(function (p) { return p - 1; }); }}
                      >
                        ‹
                      </Button>
                      <span className="px-2 small">Pág. {pagina} / {totalPaginas}</span>
                      <Button
                        size="sm"
                        variant="outline-secondary"
                        disabled={pagina >= totalPaginas}
                        onClick={function () { setPagina(function (p) { return p + 1; }); }}
                      >
                        ›
                      </Button>
                      <Button
                        size="sm"
                        variant="outline-secondary"
                        disabled={pagina >= totalPaginas}
                        onClick={function () { setPagina(totalPaginas); }}
                      >
                        »
                      </Button>
                    </div>
                  </div>
                )}
              </>
            )}
          </Card.Body>
        </Card>
      </div>
    </Container>
  );
};

export default ContaListagem;
